import React, { Component } from 'react';

import { connect } from 'react-redux'
import { bindActionCreators } from "redux";

import { LoaderWrapper } from "../../HOC"

import { getTopActivityList, deleteTopActivity } from '../../redux/actions/topactivity';
import { TableWrapper, SliderOverlay, ConfirmModal } from '../../component/common';

import { getSNo } from '../../services/helperFunctions';

import { TopActivityMappingModal } from '../../component/TopActivityMapping';

class TopActivityMappingClass extends Component {

    state = {
        headerDetails: [{
            label: "S.No",
        }, {
            label: "Activity Title",
        },
        // {
        //     label: "Traveller Description",
        // }, 
        {
            label: "Action",
        }],
        isOpen: false,
        activityId: null,
        currentId: null,
        mapId: null,
        ConfirmModalOpenStatus: false,
    }

    handleFilter = (query, value, name) => {

        if (name == "filter") {
            this.setState({
                selectedFilter: query
            })

            query = {
                pageNo: 1,
                filter: query
            }
        }

        this.props.getTopActivityList(query)

    }

    handleAdd = () => {

        this.setState({
            activityId: "",
        })

        this.toggle('isOpen')

    }

    toggle = name => {
        this.setState(prevState => ({
            [name]: !prevState[name]
        }));
    }

    handleEdit = (id, activity_id) => {

        this.setState({
            activityId: activity_id,
            mapId: id,
        })

        this.toggle('isOpen')

    }

    handleDeleteToggle = (id) => {

        this.setState({
            currentId: id
        })

        this.toggle("ConfirmModalOpenStatus")

    }

    handleDelete = () => {

        let { currentId } = this.state;

        this.props.deleteTopActivity(currentId).then(() => {

            this.props.getTopActivityList({ pageNo: 1 })

            this.toggle('ConfirmModalOpenStatus');

        })

    }

    render() {

        let { topActivityList } = this.props;

        let {
            list = [], pageMeta = {},
        } = topActivityList;

        let { headerDetails, isOpen, activityId, ConfirmModalOpenStatus, mapId } = this.state;

        let IsEmpty = list.length > 0;

        return (
            <div>
                <div class="sair-pg-header">
                    <h4 class="sair-pg-title align-self-center">
                        <span class="pg-title-icon">
                            <span class="feather-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" class="feather feather-align-left">
                                    <line x1="17" y1="10" x2="3" y2="10"></line>
                                    <line x1="21" y1="6" x2="3" y2="6"></line>
                                    <line x1="21" y1="14" x2="3" y2="14"></line>
                                    <line x1="17" y1="18" x2="3" y2="18"></line>
                                </svg>
                            </span>
                        </span>
                        Top Activity Mapping

                    </h4>
                    <div className="col-auto ">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={this.handleAdd}
                        >
                            Add Top Activity Mapping
                        </button>
                    </div>
                </div>
                <section className="sair-sec-wrapper">
                    <div className="row">
                        <div className="col-sm">
                            <div className="row no-gutters">
                                <h5 className="sair-sec-title align-self-center">
                                    Top Activity Mapping List
                                </h5>
                            </div>
                            <div className="table-wrap mt-3">
                                <TableWrapper
                                    headerDetails={headerDetails}
                                    isEmpty={IsEmpty}
                                    pageMeta={pageMeta}
                                    queryHandler={(query) => this.handleFilter(query)}
                                >
                                    {list.map((item, index) => {

                                        let {
                                            Activity = {},
                                            Category,
                                            activity_id,
                                            id,
                                        } = item;

                                        let activity = Activity ? Activity : {};

                                        // let { title: CategoryTitle, description } = Category;

                                        return (
                                            <tr key={index}>
                                                <td>
                                                    {getSNo(pageMeta, index)}
                                                </td>
                                                <td>{activity.title}</td>
                                                {/* <td>{Activity.traveller_des}</td> */}
                                                <td>
                                                    {/* <a
                                                        className="mr-25"
                                                        onClick={() => this.handleEdit(id, activity_id)}
                                                    >
                                                        <i className="icon-pencil  text-primary cursor-pointer"
                                                        ></i>
                                                    </a> */}
                                                    <a >
                                                        <i
                                                            className="icon-trash txt-danger text-primary cursor-pointer"
                                                            onClick={e => this.handleDeleteToggle(id)}
                                                        ></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        )

                                    })}
                                </TableWrapper>
                            </div>
                        </div>
                    </div>
                </section>
                <SliderOverlay isOpen={isOpen} toggle={() => this.toggle('isOpen')} size='30%'>
                    <div className="side-slider h-100 position-relative">
                        <div className="h-100 flex-with-center">
                            <TopActivityMappingModal
                                toggle={() => this.toggle('isOpen')}
                                activityId={activityId}
                                mapId={mapId}
                            />
                        </div>
                    </div>
                </SliderOverlay>
                <ConfirmModal
                    keyName="ConfirmModalOpenStatus"
                    toggle={this.toggle}
                    isOpen={ConfirmModalOpenStatus}
                    handleSubmit={() => this.handleDelete()}
                    submitText='Delete'
                >
                    <h5>
                        Are you sure want to delete Top Activity Mapping?
					</h5>
                </ConfirmModal>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        topActivityList: state.topactivity.topActivityList,
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getTopActivityList,
        deleteTopActivity
    }, dispatch)
};


let actions = ['getTopActivityList']

let component = LoaderWrapper(TopActivityMappingClass)({ actions })

export const TopActivityMapping = connect(mapStateToProps, mapDispatchToProps)(component)